exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex.flex-column[data-v-00928302]{min-height:100vh}", ""]);

// exports
